export default __webpack_public_path__ + "static/media/checked.29a95a08.svg";